import { createImageHeaderComponent } from '@vfde-brix/image-header';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

export const mountImageHeader = () => {
    const elements = document.getElementsByClassName('brix-image-header');

    for (let i = 0, x = elements.length; i < x; i += 1) {

        createImageHeaderComponent(elements[i], NO_PATTERN_BUSINESS_LOGIC);

    }
}
